const ClientRequestType = {
  Regular: 0,
  Switch: 1
};

export default ClientRequestType;
